// extracted by mini-css-extract-plugin
export default {"root":"root--AuOvn","chips":"chips--oOowE","chip":"chip--Cdkxh"};